import React, { useState, useRef, useEffect } from "react";
import { Grid, Snackbar, Alert, Switch, Button, Dialog, Modal, Box, Typography, Skeleton } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import "./QCPage.css";
import {
  useParams,
  useNavigate,
  useLoaderData,
  useLocation,
} from "react-router-dom";
import ImageViewer from "../../Component/ImageViewer";
import PageDetails from "../../Component/PageDetails";
import ImageModal from "../common/imageModal";
import { motion, AnimatePresence } from "framer-motion";
import HandsOnTable from "../../Component/DataGrids/HandsOnTable/HandsOnTable";
import CreatePostFetch from "../../ServerCalls/CreatePostFetch";
import LoadingWrapper from "../Loading/LoadingWrapper";
import { RetriveDataFromTable } from "../../Utils/RetriveDataFromTable";
import PageLeaveWrapper from "../../Utils/PageLeaveWrapper";
import { ErrorMerger } from "../../Utils/ErrorMerger";
import { storeLastVisit } from "../../Utils/StoreLastVisit";
import { DataBaseValidation } from "../../Utils/Validations/DataBaseValidation";
import ConflictDisplay from "../../Component/DialogContainer/ConflictResult/ConflictDisplay";
import useFetch from "../../useHook/useFetch";
import { useContext } from "react";
import AppContext from "../../Context/AppContext";
import { pageDataLoader } from "../../Api/ReadOnlyFetchData/GetRequests";
import CreatePostFetchJSON from "../../ServerCalls/CreatePostFetchJSON";
import { FiDownload } from "react-icons/fi";
import AvifaunaLocalityMappingModal from "../common/AvifaunaLocalityMappingModal";
import { IoIosWarning } from "react-icons/io";

const avifaunaModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 3,
  outline: "none",
};

const QCPage = (props) => {
const params = useParams();
const { type, status, page, year } = props || params;
  const [statusState, setStatusState] = useState('');
  const BASE_URL_LOC = process.env.REACT_APP_SERVER_LOCATION;
  const appState = useContext(AppContext);
  const userRole = appState.getAuthStat();

  const isAdmin = userRole === "Admin";
  const isResearcher = userRole === "Researcher";

  const getState = async () => {
    const response = await fetch(`${BASE_URL_LOC}/getState`,{
        method: "post",
        headers: {
            "authentication-token": localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "authentication-token",
            "Access-Control-Expose-Headers": "authentication-token",
            "Content-Type": "application/json",
        },
        body: JSON.stringify({file_year: year, file_name: page}),
        mode: "cors"
    });
    const data = await response.json();
    setStatusState(data?.file_status);
}

// console.log(status,"status111")

  const [TableData, setTableData] = useState({ headers: [], errorList: [] });
  const [duplicateRingWarningOpen, setDuplicateRingWarningOpen] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);

  async function loadData() {
    const loadedData = await pageDataLoader({ params: { page, year, type } });
    return loadedData;
  }

  useEffect(()=>{
    const fetchData = async () => {
      try {
        await getState();
        const loadedData = await loadData();
        setTableData((prev=>({...prev,...loadedData})));

        if(loadedData.duplicateRingNumbers && Object.keys(loadedData.duplicateRingNumbers).length > 0) {
          setDuplicateRingWarningOpen(true);
        }
      } catch (error) {
        console.error("Error in useEffect:", error);
      } finally {
        setTableLoading(false);
      }
    };
    fetchData();
  },[])




  const [[snackBarVal, snackBarMsg, snackBarType], setSnackBar] = useState([
    false,
    "File Saved",
    "info",
  ]);
  const location = useLocation();

  const [uploadedAvifauna, setAvifaunaUploaded] = useState(false)
  const [avifaunaWarningOpen, setAvifaunaWarningOpen] = useState(false);

  const [pageload, setPageLoad] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(null);

  const [detailsToggle, setdetailsToggle] = useState(
    localStorage.getItem("userPref_details")
      ? JSON.parse(localStorage.getItem("userPref_details"))
      : false
  );
  const [[conflictPop, conflictsData], setConflictsPop] = useState([false, []]);

  const [pageType, setPageType] = useState("Ringing_Page");
  const [additionInfo, setAdditionInfo] = useState({
    resightingInfo: false,
    othertext: "",
  });
  const [ringingData, setRingingData] = useState("");
  const [imageModal, setImageModal] = useState(false);
  const [avifaunaMappingOpen, setAvifaunaMappingOpen] = useState(false);

  const navigate = useNavigate();
  const TableRef = useRef(null);
  const pageDetailsRef = useRef(null);
  const deltedRows = useRef([]);
  const updatedRows = useRef([]);

  const postBuilder = CreatePostFetch();

  const confirmIfAlreadyMerged = (actionLabel) => {
    const isMerged = statusState === "Merged" || (statusState && statusState.toLowerCase() === "merged");
    const isAvifaunaUploaded = uploadedAvifauna === 1 || uploadedAvifauna === true;
  
    const warnings = [];
  
    if (isMerged) warnings.push("⚠️ The file is already Merged!");
    if (isAvifaunaUploaded) warnings.push("⚠️ Already uploaded to Avifauna!");
  
    if (warnings.length === 0) return true;
  
    return window.confirm(
      `${warnings.join("\n")}\n\nDo you still want to proceed with "${actionLabel}"?`
    );
  };

  useEffect(() => {
    const navSplit = location.pathname.split("/");
    storeLastVisit({
      filePage: navSplit[1],
      fileName: page,
      fileYear: year,
      fileStatus: status,
      fileType: navSplit[5],
    });
  }, []);
  const { data, loading } = useFetch(
    "/getPageTypeDetails?year=" + year + "&page=" + page
  );

  // useEffect(()=>{
  //   setAvifaunaUploaded(data?.avi_uploaded)
  // },[data])
  useEffect(() => {
    const isUploaded = data?.avi_uploaded === 1 || data?.avi_uploaded === true;
    setAvifaunaUploaded(isUploaded);
    if (isUploaded) {
      setAvifaunaWarningOpen(true);
    }
  }, [data])

  useEffect(() => {
    const checkIfOccupied = async () => {
      try {
        const response = await fetch(
          `${BASE_URL_LOC}/occupyPage?fileName=${page}&fileYear=${year}`,
          {
            method: "GET",
            redirect: "follow",
            headers: {
              "authentication-token": localStorage.getItem("token"),
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Headers": "authentication-token",
              "Access-Control-Expose-Headers": "authentication-token",
            },
            mode: "cors",
          }
        );

        if (response.ok) {
          const result = await response.json();
          if (result.occupied) {
            alert(`This page is already occupied by another ${result.role} .`);
          }
        } else {
          console.error("Failed to fetch occupation status.");
        }
      } catch (error) {
        console.error("Error while fetching occupation status:", error);
      }
    };

    checkIfOccupied();
  }, []);

  const postBuilderJSON = CreatePostFetchJSON();
  
  // Check if file can be unmerged (must be in Merged status)
  const canUnmerge = statusState === "Merged" || (statusState && statusState.toLowerCase() === "merged");
  const showSyncDbIds =
    isAdmin &&
    canUnmerge &&
    TableData.headers &&
    !TableData.headers.includes("database_id");

  const pageLeaveCleanUp = async () => {
    const BASE_URL_LOC = process.env["REACT_APP_SERVER_LOCATION"];

    await fetch(
      BASE_URL_LOC + "/pageLeave?fileName=" + page + "&fileYear=" + year,
      {
        method: "GET",
        redirect: "follow",
        headers: {
          "authentication-token": localStorage.getItem("token"),
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers": "authentication-token",
          "Access-Control-Expose-Headers": "authentication-token",
        },
        mode: "cors",
      }
    );
  };


  const handlePageTypeChange = (newPageType) => {
    setPageType(newPageType);
  };

  const handleAdditionalInfoChange = (newInfo) => {
    setAdditionInfo(newInfo);
  };

  const handleringingdata = (newringingdata) => {
    setRingingData(newringingdata);
  };

  useEffect(() => {
    if (typeof data !== "undefined") {
      // console.log("called");
      // console.log(data);
      setPageType(data.pageType ? data.pageType : "ringing_page");
      setRingingData(data.problemText ? data.problemText : "");
      setAdditionInfo({
        resightingInfo:
          typeof data.resightingInfo !== "undefined" &&
            data.resightingInfo !== null &&
            data.resightingInfo !== 0
            ? data.resightingInfo
            : "",
        othertext: data.otherText ? data.otherText : "",

      });
    }
  }, [data, loading]);

  const saveTable = async (saveType, toValidate) => {
    // await pageDetailsRef.current.saveDetails();

    if (TableRef !== null) {
      let data = RetriveDataFromTable(TableRef, { includeEmptyRows: isAdmin });
      const tableHeaders = TableRef.current.hotInstance.getColHeader();
      const tableApi = TableRef.current.hotInstance;

      // Validate all fields first - if validation fails, return early without API call
      // Only run validation if toValidate is true (for Submit button)
      if (toValidate) {
        const { mergeAllow, errorMessages } = DataBaseValidation(
          tableApi,
          data,
          handleSnackBarState
        );

        if (!mergeAllow) {
          const MAX_ERRORS = 5;
          const limitedErrors = errorMessages.slice(0, MAX_ERRORS);
          const remainingCount = errorMessages.length - MAX_ERRORS;

          const message =
            limitedErrors.join("\n") +
            (remainingCount > 0 ? `\n...and ${remainingCount} more errors` : "");

          setSnackBar([true, message, "error"]);
          return;
        }
      }

      let formData = new FormData();
      formData.append("data", JSON.stringify(data));
      formData.append("headers", JSON.stringify(tableHeaders));
      formData.append("fileName", page);
      formData.append("fileYear", year);
      formData.append("saveType", saveType);
      formData.append("errorObj", JSON.stringify(TableData.errorList || []));

      formData.append("pageType", pageType);
      formData.append("pageName", page);
      formData.append("pageYear", year);
      formData.append("resightingInfo", additionInfo.resightingInfo);
      formData.append("otherText", additionInfo.othertext);
      formData.append("problemText", ringingData);
      formData.append("aviUploaded", uploadedAvifauna ? 1 : 0)
      let response = await postBuilder.caller("/saveFile", formData);

      if (response.status === 200) {
        setSnackBar([true, "File Saved", "success"]);

        if (saveType === true) {
          setTimeout(() => {
            navigate("/home");
          }, 1000);
        }
      } else {
        // setSnackBar([false, "File Not Submitted", "error"]);
        const errorText = await response.text();
        setSnackBar([true, errorText || "File Not Submitted", "error"]);
      }
    }
  };

  const handleSnackBarState = (val, msg, type) => {
    setSnackBar([true, msg, type]);
  };

  const mergeTableCall = async () => {
    if (!confirmIfAlreadyMerged("Merge")) return;
    setPageLoad(true);

    if (TableRef !== null) {
      const tableApi = TableRef.current.hotInstance;

      let data = RetriveDataFromTable(TableRef);
      const tableHeaders = TableRef.current.hotInstance.getColHeader();

      // Validate all fields first - if validation fails, return early without API call
      let { mergeAllow, warnUser, errorMessages } = DataBaseValidation(
        tableApi,
        data,
        handleSnackBarState
      );
      console.log("MERGE CALLED", mergeAllow, warnUser);

      if (!mergeAllow) {
        const MAX_ERRORS = 5;
        const limitedErrors = errorMessages.slice(0, MAX_ERRORS);
        const remainingCount = errorMessages.length - MAX_ERRORS;

        const message =
          limitedErrors.join("\n") +
          (remainingCount > 0 ? `\n...and ${remainingCount} more errors` : "");

        setSnackBar([true, message, "error"]);
        setPageLoad(false);
        return;
      }

      let formData = new FormData();
      formData.append("data", JSON.stringify(data));
      formData.append("headers", JSON.stringify(tableHeaders));
      formData.append("fileName", page);
      formData.append("fileYear", year);

      if (mergeAllow) {
        if (warnUser) {
          let res = window.confirm(
            "The Page contains errors. Do you still wish to merge?"
          );
          if (res) {
            let response = await postBuilder.caller(
              "/getFinalMergedData",
              formData
            );

            if (response.status === 200) {
              let data = await response.json();
              console.log("MERGE RESPONSE ", data);
              setTableData((prevState) => {
                return {
                  img: prevState.img,
                  fileName: prevState.fileName,
                  fileYear: prevState.fileYear,
                  data: data.data,
                  headers: data.headers,
                  errorList: ErrorMerger(prevState.errorList, data.errorList),
                  back_url: prevState.back_url,
                };
              });
              setSnackBar([true, "File has been Merged", "success"]);
              if (data.mergeErrors?.length !== 0) {
                setConflictsPop([true, data.mergeErrors]);
              }
              setStatusState("Merged");
            } else {
              let responseText = await response.text();
              // let responseText = await response.json();
              setSnackBar([true, "Merge Failed :" + responseText, "error"]);
            }
          }
        } else {
          let response = await postBuilder.caller(
            "/getFinalMergedData",
            formData
          );
          if (response.status === 200) {
            let data = await response.json();
            setTableData((prevState) => {
              return {
                img: prevState.img,
                fileName: prevState.fileName,
                fileYear: prevState.fileYear,
                data: data.data,
                headers: data.headers,
                errorList: ErrorMerger(prevState.errorList, data.errorList),
                back_url: prevState.back_url,
              };
            });
            setSnackBar([true, "File has been Merged", "success"]);
            if (data.mergeErrors?.length !== 0) {
              setConflictsPop([true, data.mergeErrors]);
            }
            setStatusState("Merged");
          } else {
            let responseText = await response.text();
            // let responseText = await response.json();
            setSnackBar([true, "Merge Failed :" + responseText, "error"]);
          }
        }
      }
    }

    setPageLoad(false);
  };

  const handleDelCallBack = (id) => {
    deltedRows.current.push(id);
  };

  const handleUpdateCallback = (index) => {
    if (
      TableRef.current.hotInstance.getDataAtRowProp(index, "database_id") !==
      null
    ) {
      updatedRows.current.push(
        TableRef.current.hotInstance.getDataAtRowProp(index, "database_id")
      );
    }
  };

  const handleUnmerge = async () => {
    // confirmation
    const confirmUnmerge = window.confirm(
      "Are you sure you want to unmerge this file?"
    );
    if (!confirmUnmerge) return;

    setPageLoad(true);
    setButtonLoading("unmerge");

    try {
      // payload
      const payload = {
        fileName: page,
        fileYear: year
      };

      console.log("UNMERGE PAYLOAD", payload);

      // API call
      const response = await postBuilderJSON.caller(
        "/unmergeRingingRecords",
        payload
      );

      // handle response
      if (response.status === 200 || response.status === 400) {
        const resData = await response.json();
        console.log("UNMERGE RESPONSE", resData);

        if (response.status === 200) {
          setSnackBar([true, resData?.message, "success"]);

          // Optional: refresh table data if backend sends updated data
          if (resData.data && resData.headers) {
            setTableData(prev => ({
              ...prev,
              data: resData.data,
              headers: resData.headers,
              errorList: resData.errorList ?? [],
            }));
          }
          // Update status state
          setStatusState("QC_Done");
        } else {
          setSnackBar([
            true,
            resData?.message || resData?.error || "Unmerge failed. Please review errors.",
            "error",
          ]);
        }
      }
      // unexpected status
      else {
        const errorText = await response.text();
        setSnackBar([true, `Unmerge Failed : ${errorText}`, "error"]);
      }
    } catch (err) {
      console.error("Resighting Unmerge Error", err);
      setSnackBar([true, "Unmerge failed due to server error", "error"]);
    } finally {
      setPageLoad(false);
      setButtonLoading(null);
    }
  };

  const handleSyncDbIds = async () => {
    const confirmSync = window.confirm(
      "Sync database_id and valid columns from the database into the QC file on S3?"
    );
    if (!confirmSync) return;

    setPageLoad(true);
    setButtonLoading("syncDbIds");

    try {
      const response = await postBuilderJSON.caller("/enrich-with-db-ids", {
        file_name: page,
        file_year: year,
      });

      const resData = await response.json();

      if (response.status === 200) {
        setSnackBar([true, resData?.message || "Database IDs synced successfully", "success"]);
        const loadedData = await loadData();
        setTableData((prev) => ({ ...prev, ...loadedData }));
      } else {
        setSnackBar([
          true,
          resData?.error || resData?.message || "Failed to sync database IDs",
          "error",
        ]);
      }
    } catch (err) {
      console.error("Sync DB IDs error", err);
      setSnackBar([true, "Sync failed due to server error", "error"]);
    } finally {
      setPageLoad(false);
      setButtonLoading(null);
    }
  };

  const remergeTableCall = async () => {
    if (!confirmIfAlreadyMerged("Remerge")) return;
    setPageLoad(true);

    let confirm = window.confirm(
      "Remerging a file will ignore all non-major errors and marks all rows as valid. Are you sure you want to proceed?"
    );

    if (confirm) {
      console.log("Remerge");
      if (TableRef !== null) {
        const tableApi = TableRef.current.hotInstance;

        let data = RetriveDataFromTable(TableRef);
        const tableHeaders = TableRef.current.hotInstance.getColHeader();

        // Validate all fields first - if validation fails, return early without API call
        let { mergeAllow, warnUser, errorMessages } = DataBaseValidation(
          tableApi,
          data,
          handleSnackBarState
        );

        if (!mergeAllow) {
          const MAX_ERRORS = 5;
          const limitedErrors = errorMessages.slice(0, MAX_ERRORS);
          const remainingCount = errorMessages.length - MAX_ERRORS;

          const message =
            limitedErrors.join("\n") +
            (remainingCount > 0 ? `\n...and ${remainingCount} more errors` : "");

          setSnackBar([true, message, "error"]);
          setPageLoad(false);
          return;
        }
        let insertedList = [];
        insertedList = data.filter((e) => e["database_id"] === -1);
        data = data.filter((e) => e["database_id"] !== -1);

        let formData = new FormData();
        formData.append("data", JSON.stringify(data));
        formData.append("headers", JSON.stringify(tableHeaders));
        formData.append("fileName", page);
        formData.append("fileYear", year);
        formData.append("insertedList", JSON.stringify(insertedList));
        formData.append("deletedList", JSON.stringify(deltedRows.current));
        formData.append("updatedList", JSON.stringify(updatedRows.current));

        if (mergeAllow) {
          if (warnUser) {
            let res = window.confirm(
              "The Page contains errors. Do you still wish to merge?"
            );
            if (res) {
              let response = await postBuilder.caller("/remergeData", formData);

              if (response.status === 200) {
                let data = await response.json();
                data = { ...data, img: TableData.img, back_url: TableData.back_url };
                setTableData((prevState) => {
                  return {
                    img: prevState.img,
                    fileName: prevState.fileName,
                    fileYear: prevState.fileYear,
                    data: data.data,
                    headers: data.headers,
                    errorList: ErrorMerger(prevState.errorList, data.errorList),
                    back_url: prevState.back_url,
                  };
                });
                setSnackBar([true, "File has been Merged", "success"]);
                if (data.mergeErrors?.length !== 0) {
                  setConflictsPop([true, data.mergeErrors]);
                }
                setStatusState("Merged");
              } else {
                setSnackBar([true, "Merge Failed", "error"]);
              }
            }
          } else {
            let response = await postBuilder.caller("/remergeData", formData);
            if (response.status === 200) {
              let data = await response.json();
              data = { ...data, img: TableData.img, back_url: TableData.back_url };
              setTableData((prevState) => {
                return {
                  img: prevState.img,
                  fileName: prevState.fileName,
                  fileYear: prevState.fileYear,
                  data: data.data,
                  headers: data.headers,
                  errorList: ErrorMerger(prevState.errorList, data.errorList),
                  back_url: prevState.back_url,
                };
              });
              setSnackBar([true, "File has been Merged", "success"]);
              if (data.mergeErrors?.length !== 0) {
                setConflictsPop([true, data.mergeErrors]);
              }
              setStatusState("Merged");
            } else {
              setSnackBar([true, "Merge Failed", "error"]);
            }
          }
        }
      }
    }

    setPageLoad(false);
  };

  const handleRevertCall = async () => {
    let performAction = window.confirm(
      "Do you wish to Revert file status back to 'QC_Done' ?"
    );
    if (performAction) {
      const formBody = new FormData();
      formBody.append("fileName", page);
      formBody.append("fileYear", year);
      const res = await postBuilder.caller("/revertQcDone", formBody);
      if (res.status === 200) {
        setSnackBar([true, "File Reverted. Kindly Exit the Page", "success"]);
      } else {
        // setSnackBar([true, "Revert Failed", "error"]);
        const errorText = await res.text();
        setSnackBar([true, errorText || "Revert Failed", "error"]);
      }
    }
  };

  const handleCloseDialog = () => {
    setConflictsPop((prevState) => [false, prevState[1]]);
  };

  const handleAvifaunaTemplateDownload = async () => {
    setPageLoad(true);
    const raw = JSON.stringify({
      "file_name": page
    });
    try {
      const response = await fetch(`${BASE_URL_LOC}/avifauna_template`, {
        method: 'POST',
        headers: {
          "authentication-token": appState.getToken(),
          "Access-Control-Allow-Origin": "*",
          'Content-Type': 'application/json',
          "Access-Control-Allow-Headers": "authentication-token",
          "Access-Control-Expose-Headers": "authentication-token",
        },
        body: raw
      });
      if (!response.ok) {
        setPageLoad(false);
        setSnackBar([true, "Failed to download file", "error"]);
        throw new Error("Network response was not ok");
      }
      setPageLoad(false);

      setSnackBar([true, "File Downloaded", "success"]);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${page.replace(".jpg",".csv")}`; // <-- file name
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Download failed:", error);
    }
  }

  return (
    <PageLeaveWrapper cleanUpCall={pageLeaveCleanUp}>
      <Grid container justifyContent={"center"}>
        <Grid container item sm={12} md={12} lg={12}>
          <Grid
            item
            sm={12}
            md={6}
            lg={5}
            height={"100vh"}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            {tableLoading ? (
              <Skeleton
                variant="rounded"
                animation="wave"
                width="90%"
                height="92vh"
                sx={{ borderRadius: 2 }}
              />
            ) : (
              <div className="img-wrapper" onDoubleClick={() => setImageModal(true)}>
                <ImageViewer imageUrl={TableData.img} backImg={TableData.back_url} />
              </div>
            )}
          </Grid>

          {
            imageModal && (
              <ImageModal 
                imageUrl={TableData.img} 
                backImg={TableData.back_url} 
                onClose={() => setImageModal(false)} 
              />
            )
          }

          <Grid
            item
            sm={12}
            md={6}
            lg={7}
            height={"100vh"}
            display={"flex"}
            flexDirection={"column"}
          >
            {tableLoading ? (
              <div>
                <div style={{ 
                  padding: "0", 
                  display: "flex", 
                  flexDirection: "column", 
                  height: "90vh",
                  borderRadius: "4px",
                  overflow: "hidden",
                  justifyContent: "center",
                }}>
                  {/* Column headers row */}
                  <div style={{
                    display: "grid",
                    gridTemplateColumns: "40px 80px 90px 100px 130px 60px 50px 70px 80px 1fr",
                    borderBottom: "2px solid #b0b0b0",
                    backgroundColor: "#f0f0f0",
                    minHeight: "36px",
                  }}>
                    {Array.from({ length: 10 }).map((_, i) => (   
                      <div key={i} style={{
                        padding: "6px 8px",
                        borderRight: "1px solid #c0c0c0",
                        display: "flex",
                        alignItems: "center"
                      }}>
                        <Skeleton variant="text" animation="wave" width="80%" height={16} />
                      </div>
                    ))}
                  </div>

                  {/* Data rows */}
                  {Array.from({ length: 30 }).map((_, rowIndex) => (
                    <div key={rowIndex} style={{
                      display: "grid",
                      gridTemplateColumns: "40px 80px 90px 100px 130px 60px 50px 70px 80px 1fr",
                      borderBottom: "1px solid #e0e0e0",
                      minHeight: "24px",
                      backgroundColor: rowIndex % 2 === 0 ? "#ffffff" : "#fafafa",
                    }}>
                      {Array.from({ length: 10 }).map((_, colIndex) => (
                        <div key={colIndex} style={{
                          padding: "4px 8px",
                          borderRight: "1px solid #e8e8e8",
                          display: "flex",
                          alignItems: "center"
                        }}>
                          <Skeleton 
                            variant="text" 
                            animation="wave" 
                            width={colIndex === 0 ? "60%" : colIndex === 3 || colIndex === 4 ? "90%" : "70%"} 
                            height={14} 
                          />
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <HandsOnTable
                ref={TableRef}
                TableData={TableData}
                delRowsCallback={handleDelCallBack}
                updatedRowsCallBack={handleUpdateCallback}
                // TableLoading={ TableLoading }
              />
            )}
          </Grid>

          <Grid item sm={12} md={12} lg={12}>
            <div className="details_subsection">
              <AnimatePresence mode="wait">
                {detailsToggle && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 1 }}
                    key={"subsection_details_toggle"}
                    className="toggle_subsection"
                  >
                    <Switch
                      checked={!detailsToggle}
                      onChange={() => {
                        setdetailsToggle(!detailsToggle);
                      }}
                    />
                    Show Page Tagging Panel
                  </motion.div>
                )}

                {!detailsToggle && (
                  <motion.div
                    initial={{ height: 0 }}
                    animate={{ height: "auto" }}
                    exit={{ height: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    key={"subsection_detailsPannel"}
                  >
                    <PageDetails
                      ref={pageDetailsRef}
                      status={statusState}
                      toggleController={setdetailsToggle}
                      year={year}
                      page={page}
                      setSnackBar={setSnackBar}
                      showOptions={false}
                      pageType={pageType}
                      additionInfo={additionInfo}
                      ringingData={ringingData}
                      setPageType={handlePageTypeChange}
                      setAdditionInfo={handleAdditionalInfoChange}
                      setRingingData={handleringingdata}
                      setAvifaunaFlag={setAvifaunaUploaded}
                      avifaunaFlag={uploadedAvifauna}
                      readOnly={!isAdmin && !isResearcher}
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </Grid>

          <Grid
            item
            sm={12}
            md={12}
            lg={12}
            display={"flex"}
            justifyContent={"center"}
            gap={"1rem"}
            alignItems={"center"}
            marginTop={"1rem"}
            marginBottom={"1rem"}
          >
            {(status === "QC_Done" ||
              (status && status.toLowerCase().endsWith("done"))) && (
                <>
                  <Button
                    color="secondary"
                    variant="contained"
                    onClick={() => {
                      handleRevertCall(page);
                    }}
                  >
                    Revert
                  </Button>
                </>
              )}

            <Button
              onClick={() => {
                saveTable(false, false);
              }}
              variant="contained"
              color="success"
            >
              Save
            </Button>

            <Button
              onClick={() => {
                if (
                  window.confirm(
                    "Are you sure you want to Submit the file? Once submitted changes cannot be made to the file."
                  )
                ) {
                  saveTable(true,true);
                }
              }}
              variant="contained"
              color="success"
            >
              Submit
            </Button>
            {/* {(statusState === "Merged" ||
              (statusState && statusState.toLowerCase().endsWith("done"))) &&
              <Tooltip placement="top-start" title="This will generate the Avifauna template with Ringing Sheet Data.">

                <Button
                  variant="contained"
                  color="success"
                  onClick={
                    () => handleAvifaunaTemplateDownload()
                  }
                >
                  Avifauna
                </Button>
              </Tooltip>} */}

            {(isAdmin || isResearcher) && (statusState === "QC_Done" || (statusState && statusState.toLowerCase().endsWith("done"))) &&
              TableData.headers && (
                <Button
                  variant="contained"
                  color="success"
                  onClick={
                    (TableData.headers.includes("database_id") && 
                      (TableData.data && TableData.data.some(row => 
                        row.database_id !== null && 
                        row.database_id !== undefined && 
                        row.database_id !== "" && 
                        row.database_id !== -1
                      ))
                    )
                      ? remergeTableCall
                      : mergeTableCall
                  }
                >
                  Merge
                </Button>
              )}

            {/* Unmerge Button — Admin Only */}
            {isAdmin && canUnmerge && (
              <Tooltip
                placement="top-start"
                title={!canUnmerge ? "File is not yet merged, so can't unmerge" : ""}
              >
                <Button
                  onClick={handleUnmerge}
                  variant="contained"
                  color="warning"
                  disabled={!canUnmerge || buttonLoading === "unmerge"}
                >
                  {buttonLoading === "unmerge" ? "Unmerging..." : "Unmerge"}
                </Button>
              </Tooltip>
            )}

            {/* Sync DB IDs — Admin Only (merged, no database_id column yet) */}
            {showSyncDbIds && (
              <Tooltip
                placement="top-start"
                title="Sync database_id and valid from the database into the QC file on S3"
              >
                <Button
                  onClick={handleSyncDbIds}
                  variant="contained"
                  color="info"
                  disabled={buttonLoading === "syncDbIds"}
                >
                  {buttonLoading === "syncDbIds" ? "Syncing..." : "Sync DB IDs"}
                </Button>
              </Tooltip>
            )}

            {/* {(statusState === "Merged"  || */}
            {(isAdmin || isResearcher) && (
              (TableData.headers && TableData.headers.includes("database_id"))) && (
                <Button
                  variant="contained"
                  color="success"
                  onClick={
                    TableData.headers && TableData.headers.includes("database_id")
                      ? remergeTableCall
                      : () => {
                        console.log("Click");
                      }
                  }
                >
                  ReMerge
                </Button>
              )}

              {(isAdmin) && (statusState === "Merged") && (
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => setAvifaunaMappingOpen(true)}
                >
                  <FiDownload />
                  <span style={{ marginLeft: "5px" }}>Avifauna</span>
                </Button>
              )}
      
          </Grid>
        </Grid>

        {pageload && <LoadingWrapper />}

        <Snackbar
          open={snackBarVal}
          key={"SnackBar"}
          autoHideDuration={null}
          onClose={(event, reason) => {
            if (reason === "clickaway") {
              return;
            }
            setSnackBar((prevState) => [false, prevState[1], prevState[2]]);
          }}
        >
          <Alert
            onClose={() => setSnackBar([false, snackBarMsg, snackBarType])}
            severity={snackBarType}
            variant="filled"
            sx={{ width: "100%", whiteSpace: "pre-line" }}
          >
            {snackBarMsg}
          </Alert>
        </Snackbar>

        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={conflictPop}
          onClose={handleCloseDialog}
        >
          <ConflictDisplay conflictsData={conflictsData} />
        </Dialog>

        <AvifaunaLocalityMappingModal
          open={avifaunaMappingOpen}
          onClose={() => setAvifaunaMappingOpen(false)}
          fileName={page}
          fileYear={year}
          onNotify={(open, message, type) => setSnackBar([open, message, type])}
        />

        {/* ─── Avifauna Page Load Warning Modal ─────────────────────────────── */}
        <Modal
          open={avifaunaWarningOpen}
          onClose={() => setAvifaunaWarningOpen(false)}
          aria-labelledby="avifauna-warning-title"
          aria-describedby="avifauna-warning-description"
        >
          <Box sx={avifaunaModalStyle}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
              <IoIosWarning
                style={{
                  color: "#ff9b1b",
                  fontSize: "1.4rem",
                }}
              />
              <Typography
                id="avifauna-warning-title"
                sx={{
                  fontWeight: 700,
                  fontFamily: `"Lato", sans-serif`,
                  color: "var(--font-color-secondary)",
                  fontSize: "1.1rem",
                }}
              >
                Avifauna Upload Notice
              </Typography>
            </Box>
            <Typography
              id="avifauna-warning-description"
              variant="body2"
              sx={{
                mb: 0.5,
                fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
                color: "var(--font-color-secondary)",
                ml: 3,
              }}
            >
              This file has already been uploaded to <strong>Avifauna</strong>.
            </Typography>
            <Typography
              variant="body2"
              sx={{
                mb: 3,
                fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
                color: "var(--font-color-secondary)",
                ml: 3,
              }}
            >
              Changes via <strong>Save / Submit / Merge / ReMerge</strong> will{" "}
              <strong>not</strong> auto-reflect in Avifauna. Re-upload manually if needed.
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                onClick={() => setAvifaunaWarningOpen(false)}
                sx={{
                  fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
                  textTransform: "none",
                  px: 3,
                }}
              >
                Okay
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={duplicateRingWarningOpen}
          onClose={() => setDuplicateRingWarningOpen(false)}
          aria-labelledby="duplicate-ring-warning-title"
          aria-describedby="duplicate-ring-warning-description"
        >
          <Box sx={avifaunaModalStyle}>

            {/* Header */}
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <IoIosWarning
                  style={{
                    color: "var(--font-color-secondary)",
                    fontSize: "1.4rem",
                  }}
                />
                <Typography
                  id="duplicate-ring-warning-title"
                  sx={{
                    fontWeight: 700,
                    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
                    color: "var(--font-color-secondary)",
                  }}
                >
                  Duplicate Ring Numbers Found
                </Typography>
              </Box>
              {/* <IoMdClose
                onClick={() => setDuplicateRingWarningOpen(false)}
                style={{
                  color: "var(--font-color-secondary)",
                  fontSize: "1.2rem",
                  cursor: "pointer",
                }}
              /> */}
            </Box>

            {/* Body */}
            <Typography
              id="duplicate-ring-warning-description"
              variant="body2"
              sx={{
                mb: 0.5,
                fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
                color: "var(--font-color-secondary)",
              }}
            >
              This file contains <strong>duplicate ring numbers</strong> that already exist in the database.
            </Typography>
            <Typography
              variant="body2"
              sx={{
                mb: 3,
                fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
                color: "var(--font-color-secondary)",
              }}
            >
              Please review the highlighted rows before merging and <strong>contact the Admin</strong> if required.
            </Typography>

            {/* Action */}
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                variant="contained"
                onClick={() => setDuplicateRingWarningOpen(false)}
                sx={{
                  fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
                  textTransform: "none",
                  px: 3,
                  bgcolor: "#424242",
                  "&:hover": { bgcolor: "#212121" },
                }}
              >
                OK
              </Button>
            </Box>

          </Box>
        </Modal>

      </Grid>
    </PageLeaveWrapper>
  );
};

export default QCPage;
